import styles from './ChartCard.module.css';

function ChartCard({
    title,
    subtitle = null,
    icon: Icon = null,
    actions = null,
    children,
    loading = false,
    height = 280,
}) {
    return (
        <div className={styles.chartCard}>
            <div className={styles.header}>
                <div className={styles.titleSection}>
                    {Icon && <Icon size={20} className={styles.icon} />}
                    <div>
                        <h3 className={styles.title}>{title}</h3>
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                </div>

                {actions && (
                    <div className={styles.actions}>
                        {actions}
                    </div>
                )}
            </div>

            <div className={styles.body}>
                {loading ? (
                    <div className={styles.loading}>Loading...</div>
                ) : (
                    <div className={styles.chartContainer} style={{ height }}>
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ChartCard;
